import { Component, OnInit, ViewChild,  Output, EventEmitter } from "@angular/core";
import { IOption } from "ng-select";
import { Location } from "@angular/common";
import { BsDatepickerConfig, BsModalRef } from "ngx-bootstrap";
import { BsModalService } from "ngx-bootstrap/modal";
import { CorrectiveActionCommentForwardComponent } from "../corrective-action-comment-forward/corrective-action-comment-forward.component";
import { HelperService } from "../services/helper.service";
import { LossPreventionAccessService } from "../services/loss-prevention-access.service";
import { RilrService } from "../services/rilr.service";
import { NgxSpinnerService } from "ngx-spinner";
import { TosterMessageService } from "../services/toster-message.service";

import {TrainingCalenderModalComponent} from '../training/training-calender-modal/training-calender-modal.component';

import { IcamService } from "../services/icam.service";


@Component({
  selector: "app-corrective-action-history-modal",
  templateUrl: "./corrective-action-history-modal.component.html",
  styleUrls: ["./corrective-action-history-modal.component.scss"],
  providers: [
    RilrService,
    HelperService,
    TosterMessageService,
    LossPreventionAccessService,
    IcamService,
  ],
})
export class CorrectiveActionHistoryModalComponent implements OnInit {
  public masterData: any = {};
  public employeeOption: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public documentArr: Array<IOption> = [];
  public actionAreaSelectionArr: Array<IOption> = [];
  public reportsArr: Array<IOption> = [];

  public trainingRecordsArr: Array<IOption> = [];

  public confirmDisabled: number = 0;
  public areaActionFalse: number = 0;
  public reopenAccessCompany: number = 0;
  public reportStatus: number = 0;
  public pathFromWidget: number = 0;
  public lptCAReopenAccess: boolean = false;
  public actionFullyClosedPath: boolean = true;
  colorTheme = "theme-blue";
  bsConfig: Partial<BsDatepickerConfig>;
  isEdit: number;
  actionID: number;
  correctiveActionCommentsArr: any = [];
  correctiveActionHistoryArr: any = [];
  profilePic: string = "profileImage/default.png";
  commentActionButton: boolean = true;
  actionCompleteClose: boolean = false;
  disabledEnterAccess: boolean = true;
  disabled: boolean = false;
  lptAccessDisable: boolean = false;
  lptAccessTargetDate: boolean = false;
  public firstDayOfYear: any;
  public policyBaseAction: number = 0;
  public myActionBase: number = 0;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("swalModalActionClose") swalModalActionClose: any;
  @ViewChild("swalReopenCorrectiveAction") swalReopenCorrectiveAction: any;
  public htmlErrorMessage: string = "";

  nextActionComment: any = {
    correctiveActionID: this.actionID,
    comment: "",
  };

  companySystemID = +this.helperService.getSelectedCompanyId();

  currentUserSystemID = +this.helperService.getuserID();

  yesNoArr: any = [];

  statuses: any = [];

  yesNoArrCompetancy: any = [
    {value: 0, label: 'Open'},
  ];


  bsModalRefCorrectiveActionNew: BsModalRef;
  selectedCorrectiveAction: any = {};
  public editorConfig: any = {
    "toolbar": [
      ["bold", "italic", "underline", "strikeThrough", "superscript", "subscript"],
      ["fontName", "fontSize", "color"],
      ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull", "indent", "outdent"],
      ["cut", "copy", "delete", "removeFormat", "undo", "redo"],
      ["paragraph", "blockquote", "removeBlockquote", "horizontalLine", "orderedList", "unorderedList"],
      // ["link", "unlink", "image"],
    ],
    // "imageEndPoint": "/api/v1/upload"
  };

  @Output() tableReload: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    public bsModalRefMain: BsModalRef,
    private modalService: BsModalService,
    private rilrService: RilrService,
    private location: Location,
    private spinner: NgxSpinnerService,
    private lossPreventionAccessService: LossPreventionAccessService,
    private tosterMessageService: TosterMessageService,
    private helperService: HelperService,
    private iCamService: IcamService,
  ) {
    this.bsConfig = Object.assign(
      {},
      { containerClass: this.colorTheme, dateInputFormat: "DD/MM/YYYY" }
    );
  }

  ngOnInit() {
    this.masterData.personResEmpSystemID = [
      this.masterData.personResEmpSystemID,
    ];

    console.log(this.priorityArr);
    console.log(this.trainingRecordsArr);

    this.masterData.reportSystemID = [];
    setTimeout(() => {
      this.getCorrectiveActionComments();
      this.getCorrectiveActionHistory();
      if (this.pathFromWidget === 0) {
        this.getEmployeeLptAccess();
        this.getEmployeeOnlyLptAccess();
      }
      this.getCorrectiveActionReopen();
      if (this.policyBaseAction == 1) {
        this.fetchingReportsUpdate(this.masterData.documentSystemID, 2);
      }
      setTimeout(() => {
        if (this.masterData.submitted === 2) {
          this.confirmDisabled = 1;
        }

        this.getEmployeesEdit(this.masterData.personResEmpID);
      }, 0);

      this.getFormData();

      this.getCorrectiveActions();
      this.getiCamNotificationMultiple();

      this.modalService.onHide.subscribe((reason: string, event) => {
        if (reason) {
          if (reason === "corrective_action_forward") {
            this.getCorrectiveActionComments();
            this.getCorrectiveActionHistory();
            this.getActionForwardUser();
          }
        }
      });
      if (this.pathFromWidget === 1) {
        this.disabled = true;
      }
    }, 0);
  }

  getFormData() {
    const that = this;
    that.rilrService
      .getReportFormData()
      .get({
        companySystemID: that.companySystemID,
        type: "create",
        documentSystemID: 1,
      })
      .subscribe(
        (data) => {
          var resp = data.data.data;
          if (resp.lastCutOffDate != null) {
            that.firstDayOfYear = new Date(resp.lastCutOffDate);
          }
          this.statuses = resp.ticketStatuses;
          this.filterStatuses(this.masterData.submitted[0]);
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  filterStatuses(value) {
    this.yesNoArr = this.helperService.setSelect2DropDownOptions(
      this.statuses,
      "purpose_of_status_id",
      "name"
    );
    if (value == 0 || value == 1) {
      this.yesNoArr = this.yesNoArr.filter((s) => s.value != 3);
    } else if (value == 3) {
      this.yesNoArr = this.yesNoArr.filter((s) => s.value != 0);
    } else if (value == 2) {
      if (
        this.reopenAccessCompany == 1 &&
        this.reportStatus == 0 &&
        this.lptCAReopenAccess
      ) {
        this.yesNoArr = this.yesNoArr.filter(
          (s) => s.value == 2 || s.value == 3
        );
      } else {
        this.yesNoArr = this.yesNoArr.filter((s) => s.value == 2);
      }
    }
  }

  closeModal() {
  //  location.reload();
    console.log("Close Corrective Action");
    this.bsModalRefMain.hide();
    this.modalService.setDismissReason("corrective_action_edit_closed");
    this.modalService.setDismissReason("trainingRecordSaved");
  }



  commentButtonAction() {
    this.commentActionButton = false;
  }

  cancelCorrectiveActionComment() {
    this.commentActionButton = true;
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  getCorrectiveActionReopen() {
    const that = this;
    that.spinner.show();
    that.rilrService
      .getCorrectiveActionReopenAccess()
      .get({
        actionID: that.actionID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          let act = resp.data.data;
          that.reopenAccessCompany = act.reopenAccess;
          that.reportStatus = act.reportStatus;
          that.spinner.hide();
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  getCorrectiveActionComments() {
    const that = this;
    that.spinner.show();
    that.correctiveActionCommentsArr = [];
    that.rilrService
      .getCorrectiveActionComments()
      .get({ actionID: that.actionID })
      .subscribe(
        (resp) => {
          that.correctiveActionCommentsArr = resp.data.data;
          that.spinner.hide();
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  public createdByUserSystemID: any;

  getCorrectiveActionHistory() {
    const that = this;
    that.correctiveActionHistoryArr = [];
    that.rilrService
      .getCorrectiveActionHistory()
      .get({ actionID: that.actionID })
      .subscribe(
        (resp) => {
          that.correctiveActionHistoryArr = resp.data.data;
          that.createdByUserSystemID = that.correctiveActionHistoryArr[0].createdByUserSystemID;
          console.log(that.correctiveActionHistoryArr);
          console.log(that.createdByUserSystemID);
        },
        (error) => {}
      );
  }

  addCorrectiveActionComment() {
    const that = this;
    if (that.nextActionComment.comment != "") {
      that.spinner.show();
      that.nextActionComment.correctiveActionID = that.actionID;
      that.nextActionComment.host = window.location.origin;
      that.rilrService
        .reportCorrectiveActionCommentsCRUD()
        .post(that.nextActionComment)
        .subscribe(
          (resp) => {
            that.nextActionComment.comment = null;
            that.cancelCorrectiveActionComment();
            that.getCorrectiveActionComments();
            that.getCorrectiveActionHistory();
            that.spinner.hide();
          },
          (error) => {
            that.spinner.hide();
          }
        );
    }
  }





  addimmediateComment() {
    const that = this;
    if (that.nextActionComment.immediate != "") {
      that.spinner.show();
      that.nextActionComment.correctiveActionID = that.actionID;
      that.nextActionComment.host = window.location.origin;
      that.rilrService
        .reportCorrectiveActionCommentsCRUD()
        .post(that.nextActionComment)
        .subscribe(
          (resp) => {
            that.nextActionComment.immediate = null;
            that.cancelCorrectiveActionComment();
            that.getCorrectiveActionComments();
            that.getCorrectiveActionHistory();
            that.spinner.hide();
          },
          (error) => {
            that.spinner.hide();
          }
        );
    }
  }




  addrootcaseActionComment() {
    const that = this;
    if (that.nextActionComment.rootcase != "") {
      that.spinner.show();
      that.nextActionComment.correctiveActionID = that.actionID;
      that.nextActionComment.host = window.location.origin;
      that.rilrService
        .reportCorrectiveActionCommentsCRUD()
        .post(that.nextActionComment)
        .subscribe(
          (resp) => {
            that.nextActionComment.rootcase = null;
            that.cancelCorrectiveActionComment();
            that.getCorrectiveActionComments();
            that.getCorrectiveActionHistory();
            that.spinner.hide();
          },
          (error) => {
            that.spinner.hide();
          }
        );
    }
  }




  addActionComment() {
    const that = this;
    if (that.nextActionComment.action_plan != "") {
      that.spinner.show();
      that.nextActionComment.correctiveActionID = that.actionID;
      that.nextActionComment.host = window.location.origin;
      that.rilrService
        .reportCorrectiveActionCommentsCRUD()
        .post(that.nextActionComment)
        .subscribe(
          (resp) => {
            that.nextActionComment.action_plan = null;
            that.cancelCorrectiveActionComment();
            that.getCorrectiveActionComments();
            that.getCorrectiveActionHistory();
            that.spinner.hide();
          },
          (error) => {
            that.spinner.hide();
          }
        );
    }
  }



  public typehead(value: any): void {
    let that = this;
    if (value.length > 2) {
      that.getEmployees(value);
    } else {
      that.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
        },
        (err) => {
          console.log(err);
          that.employeeOption = [];
        }
      );
  }

  getEmployeesEdit(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
          setTimeout(() => {
            that.masterData.personResEmpSystemID =
              that.helperService.setSelectedValue(
                that.masterData.personResEmpSystemID
              );
          }, 0);
        },
        (err) => {
          console.log(err);
          that.employeeOption = [];
        }
      );
  }

  openCloseModal(field) {
    if (this.masterData.submitted && this.masterData.submitted === 2) {
      this.swalModalActionClose.show();
    } else if (this.masterData.submitted && this.masterData.submitted === 3) {
      this.swalReopenCorrectiveAction.show();
    } else {
      this.updateCorrectiveAction(field);
    }
  }

  cancelConfirmModel() {
    this.masterData.submitted = this.helperService.setSelectedValue(0);
  }

  updateCorrectiveAction(field) {
    const that = this;
    that.spinner.show();
    that.masterData.expectedCompletionDate = that.helperService.transformDate(
      that.masterData.expectedCompletionDate
    );
    that.masterData.targetDate = that.helperService.transformDate(
      that.masterData.targetDate
    );
    that.masterData.host = window.location.origin;
    that.masterData.field = field;
    that.masterData.companySystemID = that.companySystemID;
    that.rilrService
      .reportCorrectiveActionsUD(that.actionID)
      .customPUT(that.masterData)
      .subscribe(
        (resp) => {
          const temp = resp.data.data;
          that.getCorrectiveActionHistory();
          that.spinner.hide();
          if (field === "reportSystemID") {
            that.closeModal();
            this.tableReload.emit();
          }
          console.log(that.masterData.submitted);
          this.filterStatuses(that.masterData.submitted);
        },
        (error) => {
          that.htmlErrorMessage = "";
          that.htmlErrorMessage = error.data.message;
          that.showErrorHtml();
          that.masterData.submitted = this.helperService.setSelectedValue(0);
          that.spinner.hide();
          that.getCorrectiveActionHistory();
        }
      );
  }

  correctiveActionReAssign() {
    const that = this;
    that.bsModalRefCorrectiveActionNew = that.modalService.show(
      CorrectiveActionCommentForwardComponent,
      {
        class: "modal-md",
        backdrop: "static",
      }
    );
    that.bsModalRefCorrectiveActionNew.content.masterDataNew.actionID =
      that.masterData.actionID;
    that.bsModalRefCorrectiveActionNew.content.masterDataNew.personResEmpID =
      that.masterData.personResEmpID;
    that.bsModalRefCorrectiveActionNew.content.masterDataNew.personResEmpSystemID =
      that.masterData.personResEmpSystemID;
    that.disabledEnterAccess = false;
  }

  getEmployeeLptAccess() {
    const that = this;
    that.lossPreventionAccessService
      .getCorrectiveActionLptAccess()
      .get({
        actionID: that.actionID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          const temp = resp.data.data;
          if (temp.permission) {
            that.lptAccessDisable = true;
            that.disabled = false;
          } else {
            that.disabled = true;
          }
        },
        (err) => {}
      );
  }

  getEmployeeOnlyLptAccess() {
    const that = this;
    that.lossPreventionAccessService
      .getCorrectiveActionLptAccess()
      .get({
        onlyLPTAccess: 0,
        actionID: that.actionID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          const temp = resp.data.data;
          if (temp.permission) {
            that.lptCAReopenAccess = true;
            that.lptAccessTargetDate = true;
          } else {
            that.lptAccessTargetDate = false;
          }
        },
        (err) => {}
      );
  }

  getActionForwardUser() {
    const that = this;
    that.rilrService
      .getActionForwardUpdatedUser()
      .get({ actionID: that.actionID })
      .subscribe(
        (resp) => {
          const temp = resp.data.data;
          that.masterData.personResEmpID = temp.personResEmpID;
          that.masterData.personResEmpSystemID = temp.personResEmpSystemID;
          this.masterData.personResEmpSystemID = [
            this.masterData.personResEmpSystemID,
          ];
          that.getEmployeesEdit(temp.personResEmpID);
        },
        (error) => {}
      );
  }

  reopenCorrectiveActionConfirm() {
    this.swalReopenCorrectiveAction.show();
  }

  cancelCorrectiveAction() {
    this.masterData.submitted = this.helperService.setSelectedValue(2);
  }

  public reopenCorrectiveAction(data) {
    const that = this;
    if (data) {
      that.spinner.show();
      that.selectedCorrectiveAction.actionID = that.actionID;
      that.selectedCorrectiveAction.host = window.location.origin;
      that.selectedCorrectiveAction.reopenedComments = data;
      that.rilrService
        .correctiveActionsReopen()
        .post(that.selectedCorrectiveAction)
        .subscribe(
          (resp) => {
            //that.tosterMessageService.showSuccess("Success", "Successfully reopen the corrective action");
            that.closeModal();
            this.tableReload.emit();
            that.spinner.hide();
          },
          (error) => {
            that.spinner.hide();
            //that.tosterMessageService.showError("Error", "Unable to reopen corrective action");
          }
        );
    } else {
      that.tosterMessageService.showWarning(
        "Warning",
        "Please enter the comment"
      );
    }
  }

  public fetchingReports(documentSystemID) {
    this.masterData.reportSystemID = [0];
    this.fetchingReportsUpdate(documentSystemID, 1);
    this.updateCorrectiveAction("documentSystemID");
  }

  public fetchingReportsUpdate(documentSystemID, type) {
    const that = this;
    that.rilrService
      .documentBaseReports()
      .get({
        documentSystemID: documentSystemID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          const temp = resp.data.data;
          that.reportsArr = that.helperService.setSelect2DropDownOptions(
            temp,
            "reportSystemID",
            "reportDocumentCode"
          );
          if (type == 2) {
            if (that.masterData.reportSystemID != 0) {
              that.masterData.reportSystemID =
                that.helperService.setSelectedValue(
                  that.masterData.reportSystemID
                );
            }
          }
        },
        (error) => {}
      );
  }



  public gettheEvent(calendarID) {
    const calendarIDNew = calendarID[0];
    console.log(calendarIDNew);

    localStorage.setItem("training-record-id", String(calendarIDNew));
    localStorage.setItem("training-record-type", String(0));

    const masterData: any = {};
    this.bsModalRef = this.modalService.show(TrainingCalenderModalComponent, {
      class: "modal-lg",
      backdrop: "static",
    });
    this.bsModalRef.content.masterData = masterData;
    this.bsModalRef.content.calendarID = calendarIDNew;
  }











  // -------- GET CAUSE IDENTIFIED VAUES BY FILTERING ------ 

  correctiveactionstbl: any = [];

  public icamListUI: any[];
  public scatListUI: any[];
  public scatListUINew: any[];
  public criticalFactorListUI: any[];
  public causesIdentifiedListUI: any[];
  public criticalFactorListRootUI: any[];

  getCorrectiveActions() {
    let that = this;
    that.masterData.reportSystemID = that.helperService.setSelectedValue(that.masterData.reportSystemID);
    console.log(that.masterData.reportSystemID[0]);

    that.correctiveactionstbl = [];
    that.spinner.show();
    that.rilrService
      .getSelectedCorrectiveActions()
      .get({
        'reportSystemID': that.masterData.reportSystemID[0],
        'documentSystemID': 29,
        'actionID': that.actionID
      })
      .subscribe(resp => {
        that.correctiveactionstbl = resp.data.data;
        console.log(that.correctiveactionstbl);
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }




  public getiCamNotificationMultiple() {
    const that = this;
    that.masterData.reportSystemID = that.helperService.setSelectedValue(that.masterData.reportSystemID);
    that.iCamService
      .getInvestigationIcam()
      .get({
        'reportSystemID': that.masterData.reportSystemID[0],
        'companySystemID': that.companySystemID,
        'documentSystemID': 29,
      })
      .subscribe(resp => {
        const data = resp.data.data;
        that.icamListUI = that.helperService.incidentsIdChangeToInt(data.icamList);
        that.scatListUI = that.helperService.incidentsIdChangeToInt(data.scatList);
        that.criticalFactorListRootUI = that.helperService.incidentsIdChangeToInt(data.criticalFactorListRoot);
        that.causesIdentifiedListUI = that.helperService.incidentsIdChangeToInt(data.detailNine);
      }, (error) => {
      });
  }




  getLabelForSelectedCauseIcam(causes_identified_value: number, type: number): string {
    if (this.icamListUI) { 
      if (type === 1) {
        const incident_01 = this.icamListUI.find(item => item.reportIcamID === causes_identified_value);
        if (incident_01) {
          return incident_01.incidenttitle;
        } else {
          return 'Label not found in ICAM'; 
        }
      }
    } else {
      return ''; 
    }
  }
  

  getLabelForSelectedCauseScat(causes_identified_value: number, type: number): string {
    if (this.scatListUI) { 
      if (type === 2) {
        const incident_01 = this.scatListUI.find(item => item.scatID === causes_identified_value);
        if (incident_01) {
          return incident_01.incidenttitle;
        } else {
          return 'Label not found in SCAT'; 
        }
      }
    } else {
      return ''; 
    }
  }


  getLabelForSelectedCauseCFList(causes_identified_value: number, type: number): string {
    if (this.criticalFactorListRootUI) { 
      if (type === 3) {
        const incident_01 = this.criticalFactorListRootUI.find(item => item.id === causes_identified_value);
        if (incident_01) {
          return incident_01.answer;
        } else {
          return 'Label not found in Root List'; 
        }
      }
    } else {
      return ''; 
    }
  }


  getLabelForSelectedCauseCIList(causes_identified_value: number, type: number): string {
    if (this.causesIdentifiedListUI) { 
      if (type === 4) {
        const incident_01 = this.causesIdentifiedListUI.find(item => item.reportIcamID === causes_identified_value);
        if (incident_01) {
          return incident_01.description;
        } else {
          return 'Label not found in Cause Identified List'; 
        }
      }
    } else {
      return ''; 
    }
  }




  getPlaceholder(): string {
    return this.masterData.mapTrainingID || 'Choose a training';
  }
  


}



// WEBPACK FOOTER //
// /app/src/app/corrective-action-history-modal/corrective-action-history-modal.component.ts